type Props = {
  /**
   * The percentage of total Tasks that we want to check the user's usage against.
   * For example, a value of 1.0 would answer the question "has the user reached 100%
   * of their Task limit?"
   */
  percentage: number;
  /**
   * The amount of Tasks available on the account, expressed as a
   * decimal percentage of the total Task limit. For example, an account
   * with a Task limit of 100 and a `taskBuffer` of 1.2 would be able to
   * use up to 120 Tasks.
   */
  taskBufferMultiplier: number;
  taskLimit: number;
  tasksUsed: number;
};

export const accountHasReachedPercentageOfTaskLimit = ({
  percentage,
  taskBufferMultiplier,
  taskLimit,
  tasksUsed,
}: Props) => {
  const bufferedTaskLimit = taskLimit * taskBufferMultiplier;
  return tasksUsed / bufferedTaskLimit >= percentage;
};
